import { apiSlice } from "./apiSlice";

export const UserSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        userlist: builder.mutation({
            query: (data) => ({
                url: 'auth/userlist?' + data,
                method: 'GET',
                credentials: "include",
            }),

        }),
        Update_user: builder.mutation({
            query: (data) => ({
                method: "POST",
                body: data,
                url: 'updateUser',
                credentials: "include",
            })
        }),
        GetUserData: builder.mutation({
            query: (id) => ({
                method: "GET",
                url: 'productColour/' + id,
                credentials: "include",
            })
        }),
    }),
});

export const {
    useGetUserDataMutation,
    useUpdate_userMutation,
    useUserlistMutation
} = UserSlice;